import { formatValor } from '../../../utils/formatter/formatter'
import { PLANO_ANUAL, PLANO_SEMESTRAL, PLANO_TRIMESTRAL, PLANO_MENSAL } from '../../../constants'

export const getLinks = ( infosPagamento ) => {
  const parcelasTipoPlanoDict = {
    [ PLANO_ANUAL.visualizacao ]: PLANO_ANUAL.parcelas,
    [ PLANO_SEMESTRAL.visualizacao ]: PLANO_SEMESTRAL.parcelas,
    [ PLANO_TRIMESTRAL.visualizacao ]: PLANO_TRIMESTRAL.parcelas,
    [ PLANO_MENSAL.visualizacao ]: PLANO_MENSAL.parcelas,
  }
  const valorFrete = infosPagamento.valorFrete / parcelasTipoPlanoDict[ infosPagamento.tipoPlano ]
  const valor = formatValor( { 'valor': infosPagamento.valorKit + valorFrete } )

  const array = [
    {
      'route': 'trocar-forma-pagamento',
      'subtitle': `Você pode efetuar o pagamento com seu cartão de crédito. A cobrança passa a ser mensal, no valor de ${valor} por mês.`,
      'title': 'Trocar forma de pagamento'
    }
  ]

  if ( !infosPagamento.hasPagamentoPendente ) {
    let itemPix

    if ( !infosPagamento.pixPago && !infosPagamento.pixVencido && infosPagamento.urlQrCode ) {
      itemPix = {
        'linkExterno': true,
        'route': `${infosPagamento.urlQrCode}`,
        'subtitle': 'Obtenha o pix pendente para efetuar o pagamento.',
        'title': 'Ver Pix'
      }
    }

    array.splice( 0, 0, itemPix )
  }

  return array
}

export const NOVO_PIX = 'Novo Pix'

export const PAGAMENTO_DO_PIX = 'Pagamento do Pix'

export const DESCRICAO_INTERNET_BANKING = 'Copie o código e cole no site/app do seu internet banking.'

export const DESCRICAO_PAGAMENTO_LIBERACAO = 'O seu kit só será enviado após a confirmação pela instituição financeira.'

export const VISUALIZAR_PIX = 'Visualizar Pix'
